<template>
    <h1>this is updat profile page</h1>
  </template>
  
  <script>
  export default {
    name: 'UpdateProfilePage',
    components:{
      
    }
  }
  </script>
  
  